/**
 * Agent CRUD Handlers — socket event handlers for real-time agent changes.
 *
 * When agents are created/updated/deleted (via sandbox watcher or API),
 * the server emits AGENT_CREATED/UPDATED/DELETED events. These handlers
 * refresh the agent store to keep the UI in sync.
 */

import type { Socket } from "socket.io-client";
import { EVENTS } from "@/constants/events";
import { useAgentStore } from "../agentStore";

export function registerAgentCrudHandlers(socket: Socket): () => void {
  const onAgentCreated = () => {
    useAgentStore.getState().fetchMyAgents();
  };

  const onAgentUpdated = () => {
    useAgentStore.getState().fetchMyAgents();
  };

  const onAgentDeleted = () => {
    useAgentStore.getState().fetchMyAgents();
  };

  socket.on(EVENTS.AGENT_CREATED, onAgentCreated);
  socket.on(EVENTS.AGENT_UPDATED, onAgentUpdated);
  socket.on(EVENTS.AGENT_DELETED, onAgentDeleted);

  return () => {
    socket.off(EVENTS.AGENT_CREATED, onAgentCreated);
    socket.off(EVENTS.AGENT_UPDATED, onAgentUpdated);
    socket.off(EVENTS.AGENT_DELETED, onAgentDeleted);
  };
}
